import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { SseService } from 'src/app/services/SseService';

@Component({
  selector: 'app-estados-financieros',
  templateUrl: './estados-financieros.component.html',
  styleUrl: './estados-financieros.component.scss'
})
export class EstadosFinancierosComponent implements OnInit {

  @Input() compania: string = '';
  public keymetrics: any;
  public ratios: any;
  public Cashflow: any;
  public IncomeGrowth: any;
  public BalanceSheetGrowth: any;
  public FinancialGrowth: any;
  public OwnerEarnings: any;
  public EnterpriseValues: any;
  selectedTabFinancieros: number;
  public selectedFilter = 'quarter';

  constructor(private _SserService: SseService,
    private _httclient: HttpClient
  ) {
  }
  ngOnInit(): void {
    console.log("datos llegados a estadosfinancieros ", this.compania);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.cargarData();
  }

  cargarData() {
    this.cargarRatio(this.compania, this.selectedFilter);
    this.cargarkeymetric(this.compania, this.selectedFilter);
    this.cargarCashflow(this.compania, this.selectedFilter);
    this.cargarIncomeGrowth(this.compania, this.selectedFilter);
    this.cargarBalanceSheetGrowth(this.compania, this.selectedFilter);
    this.cargarFinancialGrowth(this.compania, this.selectedFilter);
    this.cargarOwnerEarnings(this.compania, this.selectedFilter);
    this.cargarEnterpriseValues(this.compania, this.selectedFilter);
  }

  cargarRatio(compania: any, periodo: any) {
    let ratioUrl = 'v3/ratios/' + compania + '?period=' + periodo;

    if (compania) {
      this._SserService.apiGetNew(ratioUrl).subscribe({
        next: (data: any) => {
          this.ratios = data;
        }
      });

    }
  }

  cargarkeymetric(compania: any, periodo: any) {
    let keymetricsUrl = 'v3/key-metrics/' + compania + '?period=' + periodo;

    if (compania) {
      this._SserService.apiGetNew(keymetricsUrl).subscribe({
        next: (data: any) => {
          this.keymetrics = data;
        }
      });
  
    }
  }
  cargarCashflow(compania: any, periodo: any) {
    let CashflowUrl = 'v3/cash-flow-statement-growth/' + compania + '?period=' + periodo;
    if (compania) {
      this._SserService.apiGetNew(CashflowUrl).subscribe({
        next: (data: any)=>{
          this.Cashflow = data;
        }
      });
    }
  }

  cargarIncomeGrowth(compania: any, periodo: any) {
    let incomeUrl = 'v3/income-statement-growth/' + compania + '?period=' + periodo;

    if (compania) {
      this._SserService.apiGetNew(incomeUrl).subscribe({
        next: (data: any)=>{
          this.IncomeGrowth = data;
        }
      });

    }
  }

  cargarBalanceSheetGrowth(compania: any, periodo: any) {
    let BalanceSheetGrowthUrl = 'v3/balance-sheet-statement-growth/' + compania + '?period=' + periodo;
    console.log("BalanceSheetGrowth", BalanceSheetGrowthUrl);
    if (compania) {
      this._SserService.apiGetNew(BalanceSheetGrowthUrl).subscribe({
        next: (data: any) => {
          this.BalanceSheetGrowth = data;
        }
      });

    }
  }

  cargarFinancialGrowth(compania: any, periodo: any) {
    let FinancialGrowthUrl = 'v3/financial-growth/' + compania + '?period=' + periodo;
    if (compania) {
      this._SserService.apiGetNew(FinancialGrowthUrl).subscribe({
        next: (data: any) => {
          this.FinancialGrowth = data;
        }
      });
    }
  }

  cargarOwnerEarnings(compania: any, periodo: any) {
    let OwnerEarningsUrl = 'v4/owner_earnings?symbol=' + encodeURIComponent(compania);

    if (compania) {
      this._SserService.apiGetNew(OwnerEarningsUrl).subscribe({
        next: (data: any) => {
          this.OwnerEarnings = data;
        }
      });
    }
  }

  cargarEnterpriseValues(compania: any, periodo: any) {
    let EnterpriseValuesUrl = 'v3/enterprise-values/' + compania + '?period=' + periodo;

    if (compania) {
      this._SserService.apiGetNew(EnterpriseValuesUrl).subscribe({
        next: (data: any) => {
          this.EnterpriseValues = data;
        }
      });
    }
  }


  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTabFinancieros = event.index;
    console.log("cambio el valor de selectedTab desde analisis data", this.selectedTabFinancieros);
  }


}
